export default __webpack_public_path__ + "static/electrical_panel_w.d2b2cd2efd383780e1b1069cbbe114ed.svg";